import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import blockDefinition from './definitions/video.json';
import BlockComponent from './BlockComponent';
import Image from './Image';
import Text from './Text';

const propTypes = {
    video: PropTypes.object,
    thumbnail: PropTypes.object,
    showThumbnail: PropTypes.bool,
    ratio: PropTypes.number,
    rounded: PropTypes.bool,
    coloredTitle: PropTypes.bool,
    coloredSubtitle: PropTypes.bool,
    coloredQuote: PropTypes.bool,
};

const defaultProps = {
    video: null,
    thumbnail: null,
    showThumbnail: true,
    ratio: null,
    rounded: false,
    coloredTitle: false,
    coloredSubtitle: false,
    coloredQuote: false,
};

class VideoBlock extends BlockComponent {

    render() {
        const { video, thumbnail, showThumbnail, ratio, rounded, ...props } = this.props;

        const hasThumbnail = typeof thumbnail !== 'undefined' && thumbnail !== null;

        const blockClassName = classNames({
            'block-video': true,
            'with-thumbnail': hasThumbnail && showThumbnail,
            rounded,
        });

        const embedStyle = {
            paddingBottom: ratio !== null ? `${ratio * 100}%` : null,
        };

        return (
            <div
                className={blockClassName}
            >
                { hasThumbnail && showThumbnail ? (
                    <Image
                        {...props}
                        ratio={ratio !== null ? ratio : undefined}
                        media={thumbnail}
                        className="block-video-thumbnail"
                        fancyboxSelector=".block-video .embed"
                    />
                ) : null }
                { video !== null && typeof video.html !== 'undefined' ? (
                    <div
                        className="embed"
                        style={embedStyle}
                        dangerouslySetInnerHTML={{ __html: video.html }}
                    />
                ) : null }
                <Text
                    {...props}
                />
            </div>
        );
    }
}

VideoBlock.propTypes = propTypes;
VideoBlock.defaultProps = defaultProps;
VideoBlock.blockDefinition = blockDefinition;

export default VideoBlock;



// WEBPACK FOOTER //
// ./components/blocks/Video.jsx